import React, { useState } from 'react';
import { ScrollView } from 'react-native';
import { DNABox, Iffy } from '@alucio/lux-ui';
import { Options, usePresentationSelector } from './PresentationSelectorStateProvider';
import FilterButton, { VariantOptions } from 'src/components/QuickFilters/FilterButton';
import FiltersSidebar from 'src/components/QuickFilters/FiltersSidebar';
import { DNADocumentFiltersChips } from 'src/components/DNA/Document/DNADocumentFilters';
import Header from './Header';
import SubHeader from './SubHeader';
import Content from './Content';
import LowerActionBar from './LowerActionBar';

const PresentationSelector: React.FC = () => {
  const {
    isSelectionMode,
    selectedDocumentVersionORM,
    selectedTab,
    currentTab,
    filterDocuments,
    isLoadingSearch,
  } = usePresentationSelector()
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [selectorWidth, setSelectorWidth] = useState(0);
  const narrowSelector = selectorWidth < 640;
  const showFilters = !selectedDocumentVersionORM &&
    (selectedTab === Options.LIBRARY || selectedTab === Options.SEARCH_RESULTS);

  return (
    <DNABox
      fill
      appearance="col"
      onLayout={event => setSelectorWidth(event.nativeEvent.layout.width)}
      style={{ display: isSelectionMode ? undefined : 'none' }}
    >
      <Header compact={selectorWidth > 0 && narrowSelector} />
      {showFilters ? (
        <DNABox alignY="center" wrap="start" spacing="sm" style={{ marginHorizontal: 16, marginVertical: 16 }}>
          <FilterButton
            filtersVisible={filtersVisible}
            setFiltersVisible={setFiltersVisible}
            variant={VariantOptions.library}
          />
          <DNADocumentFiltersChips
            documents={currentTab[selectedTab].items}
            isLoading={selectedTab === Options.SEARCH_RESULTS && isLoadingSearch}
            compact
          />
        </DNABox>
      ) : <SubHeader />}
      <DNABox fill appearance={narrowSelector ? 'col' : 'row'} style={{ minWidth: 0 }}>
        {showFilters && filtersVisible && (
          <ScrollView
            style={narrowSelector
              ? { width: '100%', maxHeight: '40%', flexGrow: 0 }
              : { width: '40%', maxWidth: 280 }}
          >
            <FiltersSidebar
              setVisible={setFiltersVisible}
              disableQuickFilters
              documents={filterDocuments}
              style={{ width: '100%' }}
            />
          </ScrollView>
        )}
        <DNABox fill appearance="col" style={{ minWidth: 0, minHeight: 0 }}>
          <Content filtersVisible={narrowSelector || (showFilters && filtersVisible)} />
        </DNABox>
      </DNABox>
      <Iffy is={selectedDocumentVersionORM}>
        <LowerActionBar/>
      </Iffy>
    </DNABox>
  )
}

export default PresentationSelector
